import Vue from 'vue';
import Plyr from 'plyr';

Vue.component('video-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            video: null,
            videoPlaying: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        Vue.nextTick(() => {
            Vue.nextTick(this.setupVideo);
        });
    },
    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        playVideo() {
            this.video.play();
            this.videoPlaying = true;

            // document.getElementById('overlayVideo').style.display = 'none';
        },
        setupVideo() {
            this.video = new Plyr('#player', {
                settings: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
            });
            if (!this.video) {
                return;
            }
            this.video.on('play', (event) => {
                this.videoPlaying = true;
                document.getElementById('play-icon').style.display = 'none';
            });
            this.video.on('pause', (event) => {
                this.videoPlaying = false;
                document.getElementById('play-icon').style.display = 'block';
            });
            this.video.on('seeking', (event) => {
                this.videoPlaying = true;
            });
            this.video.on('ended', (event) => {
                this.videoPlaying = false;
            });
        },
    },
});
